// @flow

import PropTypes from 'prop-types';
import _ from 'lodash';
import type { HealthBenefitType } from 'web-core/types/benefit';

// TODO: Deprecate PropTypes
const HealthBenefitShape = {
  benefit: PropTypes.object,
  isPostDeductible: PropTypes.bool,
  isVerbose: PropTypes.bool,
  suffix: PropTypes.string,
};

const BenefitRowType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(HealthBenefitShape)]).isRequired,
});

export const BenefitCostListPropTypes = {
  benefits: PropTypes.arrayOf(BenefitRowType).isRequired,
};

type BenefitType = {
  key: string,
  value: HealthBenefitType,
};

export type BenefitCostListType = Array<BenefitType>;

const getDisclaimerIndex = (benefit: BenefitType, benefits: BenefitCostListType) => {
  const benWithQty = _.filter(benefits, b => _.get(b, 'value.preQty'));
  const index = _.findIndex(
    benWithQty,
    b => _.get(b, 'value.preQty') === _.get(benefit, 'value.preQty'),
  );
  return index > -1 ? index + 1 : 0;
};

// const getDisclaimerIndex = (benefit, benefits) => (
//   _.findIndex(benefits, b => (
//     _.get(b, 'value.preQty') > 0
//     && _.get(b, 'value.preQty') === _.get(benefit, 'value.preQty')
//   )) + 1
// );

export const getUniqDisclaimers = (benefits: BenefitCostListType) =>
  _.uniqBy(benefits, b => _.get(b, 'value.preQty'));

export const getDisclaimerAsterisk = (benefit: BenefitType, benefits: BenefitCostListType) =>
  _.times(getDisclaimerIndex(benefit, benefits), () => '*').join('');
